import EncryptionService from '@/lib/EncryptionService';
import { useContext } from 'react';
import { EncryptionContext } from '../Providers/EncryptionProvider';

export default function useEncryptionService(): EncryptionService {
  return useContext(EncryptionContext);
}
